import { VueQueryPlugin, QueryClient } from "@tanstack/vue-query";
import { onAPICustomerIDChange } from "@/classes/apiConfig";
import { invalidateAPISession, onAPISessionChange } from "@/services/apiSession";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // Data considered fresh for 5 minutes
            gcTime: 30 * 60 * 1000, // Cache kept for 30 minutes
            refetchOnWindowFocus: "always", // Reconcile even inside staleTime
            refetchOnReconnect: "always",
            retry: 1, // Retry failed requests once
        },
    },
});

// Query keys describe resources within a tenant. Clear the entire client at
// the Customer-ID boundary so cached data can never leak into another tenant
// after domain selection, account switching, or an HMR-preserved session.
const stopClearingQueriesOnSessionChange = onAPISessionChange(() => {
    // Cancellation also fences a queryFn that doesn't consume AbortSignal: its
    // eventual result cannot repopulate the next user's cache.
    void queryClient.cancelQueries();
    queryClient.clear();
});
const stopClearingQueriesOnCustomerChange = onAPICustomerIDChange(invalidateAPISession);

if (import.meta.hot) {
    import.meta.hot.dispose(() => {
        stopClearingQueriesOnCustomerChange();
        stopClearingQueriesOnSessionChange();
    });
}

export { VueQueryPlugin };
